import BsCheckbox from './index.vue'
export default BsCheckbox